import React, { Component } from 'react';
import Moment from 'react-moment';
import '../../../App.css';
import '../../../styles/app-demo.css';
import billPayGraphic from '../../../assets/mobile-app/bill-pay-graphic.png';
import AppFooter from '../app-footer';

class BillPayLanding extends Component {

  render() {

    const billPayList = this.props.paymentList.map((item, i) => {
      return (
        <li key={i}>
          <div className="app-list-row-1">
            <p>{item.name}</p>
            <span>{item.amount}</span>
          </div>
          <div className="app-list-row-2">
            <Moment format="MM/DD/YYYY">{item.date}</Moment>
          </div>
        </li>
      )
    })

    return (
      <div className="fintwist-interactive-mobile">
        <section className="mobile-app-wrapper">
          <div className="orange-header">
            <h2>Bill Pay</h2>
          </div>
        <div className="mobile-app-dashboard">
            <div onClick={() => this.props.handleBillPayRoute('select payee')} id="bill-pay-header">
              <img src={billPayGraphic} alt={''} />
              <p>PAY A BILL</p>
            </div>
            <div className="list-header">
              <p>Pending Transactions</p>
            </div>
            <ul className="app-list">
              {billPayList}
            </ul>
          </div>
        </section>
        <AppFooter {...this.props} toggleNewRoute={this.props.toggleNewRoute} />
      </div>
    );
  }
}

export default BillPayLanding;
